"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultBar = void 0;
/* eslint-disable react/jsx-no-bind */
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const react_router_dom_1 = require("react-router-dom");
const styles_1 = require("@material-ui/core/styles");
const SimpleGrid_1 = require("../../SimpleGrid");
const Search_1 = __importDefault(require("@material-ui/icons/Search"));
const drawerWidth = 240;
// eslint-disable-next-line @rushstack/typedef-var
const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    colLeft: {
        width: drawerWidth - theme.spacing(4)
    },
    colRight: {
        width: drawerWidth - theme.spacing(4),
        textAlign: 'right'
    },
    colMiddle: {
        width: `calc(100% - ${drawerWidth}px - ${drawerWidth}px + ${theme.spacing(8)}px)`
    },
    userButton: {
        lineHeight: 0.7,
        textAlign: 'right',
        textTransform: 'initial'
    },
    searchContainer: {
        maxWidth: 600,
        textAlign: 'center',
        margin: '10px auto'
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: theme.shadows[0],
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        userSelect: 'none'
    },
    appLogo: {
        color: theme.palette.primary.main,
        textTransform: 'none',
        fontSize: '1.1rem'
    },
    searchButton: {
        transitionProperty: 'none'
    },
    notchedOutline: {
        borderColor: 'transparent'
    },
    rootOutline: {
        backgroundColor: '#f0f0f0'
    },
    focusedOutline: {
        backgroundColor: '#fff'
    }
}));
const DefaultBar = (props) => {
    const classes = useStyles();
    const { componentLogo, appName, searchBarPlaceholder, showSearchBar } = props;
    return (react_1.default.createElement(core_1.AppBar, { position: "fixed", color: "inherit", elevation: 1, className: classes.appBar },
        react_1.default.createElement(core_1.Toolbar, null,
            react_1.default.createElement("div", { className: classes.colLeft },
                react_1.default.createElement(core_1.Button, { to: "/", component: react_router_dom_1.Link, disabled: true }, componentLogo ? componentLogo : react_1.default.createElement("span", { className: classes.appLogo }, appName))),
            react_1.default.createElement("div", { className: classes.colMiddle }, showSearchBar && (react_1.default.createElement("div", { className: classes.searchContainer },
                react_1.default.createElement(core_1.TextField, { disabled: true, fullWidth: true, placeholder: searchBarPlaceholder, variant: "outlined", InputProps: {
                        classes: {
                            notchedOutline: classes.notchedOutline,
                            root: classes.rootOutline,
                            focused: classes.focusedOutline
                        },
                        startAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "start" },
                            react_1.default.createElement(Search_1.default, null)))
                    } })))),
            react_1.default.createElement("div", { className: classes.colRight },
                react_1.default.createElement(core_1.Button, { classes: { label: classes.userButton }, disabled: true },
                    react_1.default.createElement(SimpleGrid_1.SimpleGrid, { justify: "space-around", left: react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(core_1.Typography, null,
                                react_1.default.createElement(lab_1.Skeleton, { width: 75 })),
                            react_1.default.createElement(core_1.Typography, { variant: "caption" },
                                react_1.default.createElement(lab_1.Skeleton, { width: 55 }))), right: react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(lab_1.Skeleton, { variant: "circle", style: { marginLeft: 10, width: 45, height: 45 } })) })))),
        react_1.default.createElement(core_1.LinearProgress, null)));
};
exports.DefaultBar = DefaultBar;
//# sourceMappingURL=DefaultBar.js.map